export default "__VITE_ASSET__Cszi35LM__"